import React, { useEffect, useState } from "react";
import Input from "../../../../form/Input";
import Select from "../../../../../components/form/select/Select";
import useForm from "../../../../../hooks/useForm";
import Button from "../../../../form/Button";
import Textarea from "../../../../form/Textarea";
import Tags from "../../../../form/Tags";
import { useMutation, useQuery } from "@tanstack/react-query";
import { planAddEdit, planDetails } from "../../../../../services/planService";
import Switch from "../../../../form/Switch";
import FileUploadSingle from "../../../../form/FileUploadSingle";

let validation = {
  name: { required: true, message: "Name is required" },
  code: { required: true, message: "Code  is required" },
};

const ManagePlanProduct = ({
  getResponse = () => {},
  close = () => {},
  data,
}) => {
  const {
    values,
    handleChange,
    handleSubmit,
    errors,
    setFieldsValue,
    formValidate,
  } = useForm({ validationRules: validation });
  const [metadata, setMetadata] = useState([
    {
      name: "",
      key: "",
      description: "",
      dataType: "string",
      defaultValue: "",
    },
  ]);

  const [pricingData, setPricingData] = useState([
    {
      price: "",
      priceDescription: "",
    },
  ]);

  const {
    data: details,
    isLoading: detailsLoading,
    isFetching: detailsFetching,
  } = useQuery({
    queryKey: ["plan-details", data?._id],
    queryFn: async () => {
      const res = await planDetails({ id: data?._id });
      return res?.data;
    },
    enabled: !!data?._id,
  });

  console.log({ details, detailsLoading, detailsFetching });

  const handleMetaDataChange = (index, field, value) => {
    const newMetadata = [...metadata];

    if (field === "type") {
      newMetadata[index] = {
        ...newMetadata[index],
        [field]: value,
        defaultValue: "",
      };
    } else {
      newMetadata[index][field] = value;
    }

    setMetadata(newMetadata);
  };

  const addField = () => {
    setMetadata([
      ...metadata,
      {
        name: "",
        key: "",
        description: "",
        dataType: "string",
        defaultValue: "",
      },
    ]);
  };

  const removeField = (index) => {
    setMetadata(metadata.filter((_, i) => i !== index));
  };

  const addPriceField = () => {
    setPricingData([
      ...pricingData,
      {
        price: "",
        priceDescription: "",
      },
    ]);
  };

  const removePriceField = (index) => {
    setPricingData(pricingData?.filter((_, i) => i !== index));
  };
  const handlePricingDataChange = (index, field, value) => {
    const newPricingdata = [...pricingData];

    newPricingdata[index][field] = value;

    setPricingData(newPricingdata);
  };

  useEffect(() => {
    if (details?._id) {
      setFieldsValue({
        name: details?.name,
        code: details?.code,
        shortDescription: details?.description,
        description: details?.longDescription,
        tags: details?.tags?.map((item) => ({
          label: item,
          value: item,
        })),
        paymentType:
          details?.plaPricingnDetail &&
          Array?.isArray(details?.plaPricingnDetail) &&
          details?.plaPricingnDetail?.length > 0 &&
          details?.plaPricingnDetail[0]?.paymentType,
      });
      const featuresData =
        details?.features &&
        Array?.isArray(details?.features) &&
        details?.features?.length > 0
          ? details?.features
          : [];

      const pricingData =
        details?.plaPricingnDetail &&
        Array?.isArray(details?.plaPricingnDetail) &&
        details?.plaPricingnDetail?.length > 0
          ? details?.plaPricingnDetail?.map((it) => ({
              _id: it?._id,
              price: it?.price,
              priceDescription: it?.priceDescription,
            }))
          : [];
      setMetadata(featuresData);
      setPricingData(pricingData);
    }
  }, [details]);

  const {
    mutate,
    error,
    isPending: isLoading,
  } = useMutation({
    mutationFn: async (val) => {
      const payload = {
        name: values?.name,
        code: values?.code,
        description: values?.shortDescription,
        longDescription: values?.description,
        file: values?.file,
        tags: values?.tags
          .filter((item) => item && item.label)
          .map((item) => item.label),
        pricing:
          pricingData &&
          Array?.isArray(pricingData) &&
          pricingData?.map((item) => {
            const base = {
              paymentType: values?.paymentType,
              priceDescription: item?.priceDescription,
              price: item?.price,
            };
            if (details?._id && item?._id) {
              base._id = item._id;
            }

            return base;
          }),
        features:
          metadata && Array?.isArray(metadata) && metadata?.length > 0
            ? metadata
            : [],
      };
      return await planAddEdit({
        ...payload,
        ...(data?._id && { id: data?._id }),
      });
    },
    onSuccess: (res) => {
      getResponse(res);
      return res;
    },
    onError: (error) => {
      console.log(error);
    },
  });

  return (
    <form onSubmit={(event) => handleSubmit(event, mutate)}>
      <div className="grid grid-cols-12 gap-x-4 gap-y-4 m-4">
        <div className="relative col-span-12">
          <Input
            label="Name"
            inputPlaceholder={
              "Enter name of the product or service,visible to customers"
            }
            inputName="name"
            value={values?.name || ""}
            onChange={handleChange}
            {...formValidate(errors, "name")}
          />
        </div>

        <div className="relative col-span-12">
          <Input
            label="Code"
            inputPlaceholder={"Enter code"}
            inputName="code"
            value={values?.code || ""}
            onChange={handleChange}
            {...formValidate(errors, "code")}
          />
        </div>
        <div className="relative col-span-12">
          <Textarea
            label={"Short Description"}
            inputPlaceholder={
              "Appears at checkout, on the customer portal and in quotes"
            }
            inputName="shortDescription"
            inputValue={values?.shortDescription || ""}
            onChange={handleChange}
          />
        </div>
        <div className="relative col-span-12">
          <Tags
            label="Tags"
            placeholder={"Enter tags"}
            value={values?.tags}
            dropdownData={values?.tags}
            onChange={(val) => {
              handleChange({ target: { name: "tags", value: val } });
            }}
          />
        </div>
        <div className="relative col-span-12">
          <Textarea
            label={"Description"}
            inputPlaceholder={"Enter description"}
            inputName="description"
            inputValue={values?.description || ""}
            onChange={handleChange}
          />
        </div>
        <div className="relative col-span-12">
          <FileUploadSingle
            label={"Upload Image"}
            labelClasses={"!mb-2"}
            value={values?.file}
            onChange={(file) =>
              handleChange({ target: { name: "file", value: file } })
            }
          />
        </div>
        <div className="relative col-span-12 bg-white border border-primary rounded-md px-4 py-4">
          <div className="text-lg font-semibold text-slate-700  mb-1">
            Pricing
          </div>
          <div className="col-span-12">
            <Select
              label={"Payment Type"}
              required={true}
              placeholder={"Select payment type"}
              onChange={(val) => {
                handleChange({
                  target: { name: "paymentType", value: val },
                });
                setPricingData([
                  {
                    price: "",
                    priceDescription: "",
                  },
                ]);
              }}
              selectedValue={values?.paymentType}
              dropdownData={[
                { name: "Recurring", value: "recurring" },
                { name: "One-time", value: "one-time" },
              ]}
              {...formValidate(errors, "paymentType")}
            />
          </div>

          {pricingData?.map((item, index) => (
            <div
              key={index}
              className="grid grid-cols-12 gap-4 items-center bg-slate-50 border border-slate-100 px-4 py-4 mt-2 rounded-lg"
            >
              <div className="col-span-12">
                <Input
                  label="Price"
                  inputPlaceholder={"Enter price"}
                  inputName={`price-${index}`}
                  value={item.price}
                  onChange={(e) =>
                    handlePricingDataChange(index, "price", e.target.value)
                  }
                />
              </div>

              <div className="col-span-12">
                <Textarea
                  label="Price Description"
                  inputPlaceholder={"Enter price description"}
                  inputName={`priceDescription-${index}`}
                  inputValue={item?.priceDescription || ""}
                  onChange={(e) =>
                    handlePricingDataChange(
                      index,
                      "priceDescription",
                      e.target.value
                    )
                  }
                />
              </div>

              <div className="col-span-2 text-right">
                {pricingData?.length > 1 && (
                  <Button
                    type="button"
                    buttonClasses={" !text-rose-500 !bg-transparent"}
                    buttonLabel={""}
                    buttonIcon={"fa-solid fa-trash"}
                    buttonIconPosition="left"
                    buttonFunction={() => removePriceField(index)}
                  />
                )}
              </div>
            </div>
          ))}
          {values?.paymentType === "recurring" && (
            <div className="relative mt-2">
              <Button
                buttonLabel={"Add more price"}
                buttonClasses={""}
                buttonLabelClasses={"mx-auto"}
                buttonFunction={addPriceField}
              />
            </div>
          )}
        </div>
        <div className="relative col-span-12 bg-white border border-primary rounded-md px-4 py-4">
          <div className="text-lg font-semibold text-slate-700  mb-1">
            Features
          </div>

          {metadata?.map((item, index) => (
            <div
              key={index}
              className="grid grid-cols-12 gap-4 items-center bg-slate-50 border border-slate-100 px-4 py-4 mt-2 rounded-lg"
            >
              <div className="col-span-12">
                <Input
                  label="Feature Name"
                  inputPlaceholder={"Enter feature name"}
                  inputName={`name-${index}`}
                  value={item.name}
                  onChange={(e) =>
                    handleMetaDataChange(index, "name", e.target.value)
                  }
                />
              </div>
              <div className="col-span-12">
                <Input
                  inputPlaceholder="Key"
                  label="Lookup Key"
                  inputName={`key-${index}`}
                  value={item.key}
                  onChange={(e) =>
                    handleMetaDataChange(index, "key", e.target.value)
                  }
                />
              </div>
              <div className="col-span-12">
                <Textarea
                  label={"Description"}
                  inputPlaceholder={"Enter description"}
                  inputName={`description-${index}`}
                  inputValue={item?.description || ""}
                  onChange={(e) =>
                    handleMetaDataChange(index, "description", e.target.value)
                  }
                />
              </div>
              <div className="col-span-12">
                <Select
                  label={"Type"}
                  placeholder={"Select type"}
                  onChange={(e) => {
                    handleMetaDataChange(index, "dataType", e);
                  }}
                  selectedValue={item?.dataType}
                  dropdownData={[
                    { name: "Input(Number)", value: "number" },
                    { name: "Input(Text)", value: "string" },
                    { name: "Radio", value: "boolean" },
                  ]}
                />
              </div>
              {item?.dataType === "string" && (
                <div className="col-span-12">
                  <Input
                    inputPlaceholder="Value"
                    label="Value"
                    inputName={`defaultValue-${index}`}
                    value={item.defaultValue}
                    onChange={(e) =>
                      handleMetaDataChange(
                        index,
                        "defaultValue",
                        e.target.value
                      )
                    }
                  />
                </div>
              )}
              {item?.dataType === "number" && (
                <div className="col-span-12">
                  <Input
                    inputPlaceholder="Value"
                    inputType={"number"}
                    label="Value"
                    inputName={`defaultValue-${index}`}
                    value={item.defaultValue}
                    onChange={(e) =>
                      handleMetaDataChange(
                        index,
                        "defaultValue",
                        e.target.value
                      )
                    }
                  />
                </div>
              )}
              {item?.dataType === "boolean" && (
                <>
                  <Switch
                    className={
                      "!w-10 !h-5 before:!w-4 before:!h-4 peer-checked:before:!left-[22px]"
                    }
                    checked={item.defaultValue}
                    onChange={(e) => {
                      handleMetaDataChange(
                        index,
                        "defaultValue",
                        e.target.checked
                      );
                    }}
                  />
                </>
              )}

              <div className="col-span-2 text-right">
                {metadata?.length > 1 && (
                  <Button
                    type="button"
                    buttonClasses={" !text-rose-500 !bg-transparent"}
                    buttonLabel={""}
                    buttonIcon={"fa-solid fa-trash"}
                    buttonIconPosition="left"
                    buttonFunction={() => removeField(index)}
                  />
                )}
              </div>
            </div>
          ))}

          <div className="relative mt-2">
            <Button
              buttonLabel={"Add more featurs"}
              buttonClasses={""}
              buttonLabelClasses={"mx-auto"}
              buttonFunction={addField}
            />
          </div>
        </div>
      </div>
      <div className="relative col-span-4 mt-5">
        <div className="flex items-center justify-center gap-4">
          <Button
            buttonType="submit"
            buttonLabel={"Save"}
            buttonClasses={
              "!rounded-full !px-8 !h-12 !border !border-primary !bg-transparent !text-primary hover:!bg-primary hover:!text-white"
            }
            buttonLabelClasses={"mx-auto"}
            {...(isLoading && {
              loading: true,
              buttonIconPosition: "left",
              isDisable: true,
            })}
          />
          <Button
            buttonLabel={"Cancel"}
            buttonClasses={
              "!rounded-full !px-8 !h-12 !border !border-primary !bg-transparent !text-primary hover:!bg-primary hover:!text-white"
            }
            buttonLabelClasses={"mx-auto"}
            buttonFunction={close}
          />
        </div>
      </div>
    </form>
  );
};

export default ManagePlanProduct;
